module.exports = __webpack_public_path__ + "img/gl3.0542c932.jpg";